import { InputWithSuggestions } from './InputWithSuggestions'

export default InputWithSuggestions
